import { jsx as _jsx } from "react/jsx-runtime";
import { easeQuadInOut } from 'd3-ease';
import { animated, Globals, useSpring } from 'react-spring';
import { styled } from 'styled-components';
export const Loader = ({ size = 16, strokeWidth = 3 }) => {
    const circleSize = size / 2;
    const circleRadius = circleSize - strokeWidth / 2;
    const circleDash = 2 * Math.PI * circleRadius;
    const strokeDashoffset = [
        circleDash - (10 * circleDash) / 100,
        circleDash / 2,
    ];
    const svgStyles = useSpring({
        config: {
            duration: 600,
        },
        from: {
            rotate: 0,
        },
        loop: !Globals.skipAnimation,
        to: {
            rotate: 360,
        },
    });
    const circleStyles = useSpring({
        config: {
            duration: 1600,
            ease: easeQuadInOut,
        },
        from: {
            x: 0,
        },
        loop: !Globals.skipAnimation,
        to: {
            x: 1,
        },
    });
    return (_jsx(LoaderWrapper, { "data-testid": "loader", children: _jsx(animated.svg, { "data-testid": "loader-svg", height: size, style: svgStyles, viewBox: `0 0 ${size} ${size}`, width: size, children: _jsx(animated.circle, { cx: circleSize, cy: circleSize, "data-testid": "loader-circle", fill: "none", r: circleRadius, stroke: "currentColor", strokeDasharray: circleDash, strokeWidth: strokeWidth, style: {
                    strokeDashoffset: circleStyles.x.to({
                        output: [
                            strokeDashoffset[0],
                            strokeDashoffset[1],
                            strokeDashoffset[0],
                        ],
                        range: [0, 0.5, 1],
                    }),
                } }) }) }));
};
const LoaderWrapper = styled.div `
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
//# sourceMappingURL=Loader.js.map